// ============================================================================
// FSA OPENING BALANCE VERIFICATION SERVICE  (ADR-0007)
// ============================================================================

import { get, post, put } from '../../client/axiosClient';
import { fsaObVerificationEndpoints } from '../../endpoints/fsa/fsaObVerification.endpoints';
import type { ApiResponse, ID } from '../../types';
import type {
  ObVerificationWorkspace,
  SaveObAnnotationsRequest,
} from '../../types/fsa/obVerification.types';

class FsaObVerificationService {
  async getWorkspace(engagementId: ID): Promise<ApiResponse<ObVerificationWorkspace>> {
    const r = await get<ApiResponse<ObVerificationWorkspace>>(
      fsaObVerificationEndpoints.workspace(engagementId),
    );
    return r.data;
  }

  /** Uploads the client's opening TB (replaces any previous upload). Optional column mapping — same contract as the TB upload wizard. */
  async upload(
    engagementId: ID,
    source: string,
    file: File,
    columnMap?: import('../../types/fsa/trialBalance.types').TrialBalanceColumnMap | null,
  ): Promise<ApiResponse<ObVerificationWorkspace>> {
    const form = new FormData();
    form.append('source', source);
    form.append('file', file);
    if (columnMap) form.append('columnMap', JSON.stringify(columnMap));
    const r = await post<ApiResponse<ObVerificationWorkspace>>(
      fsaObVerificationEndpoints.upload(engagementId),
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return r.data;
  }

  async saveAnnotations(engagementId: ID, request: SaveObAnnotationsRequest): Promise<ApiResponse<ObVerificationWorkspace>> {
    const r = await put<ApiResponse<ObVerificationWorkspace>>(
      fsaObVerificationEndpoints.annotations(engagementId),
      request,
    );
    return r.data;
  }

  async getPdfBlob(engagementId: ID): Promise<Blob> {
    const r = await get<Blob>(fsaObVerificationEndpoints.pdf(engagementId), { responseType: 'blob' });
    return r.data;
  }

  async getExcelBlob(engagementId: ID): Promise<Blob> {
    const r = await get<Blob>(fsaObVerificationEndpoints.excel(engagementId), { responseType: 'blob' });
    return r.data;
  }
}

export const fsaObVerificationService = new FsaObVerificationService();
export default fsaObVerificationService;
